import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { ethers } from "ethers";
import abi from "./abi.json";
import "../public/style.css";

const contractAddress = "0xF2fCc9b35439344B36F8e44c005a5cfCFf4513Bb";
const contractABI = abi;

const App = () => {
  const [currentAccount, setCurrentAccount] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [memos, setMemos] = useState([]);

  useEffect(() => {
    isWalletConnected();
    if (window.ethereum) {
      (window.ethereum as any).on("chainChanged", () => {
        window.location.reload();
      });
    }
  }, []);

  const isWalletConnected = async () => {
    try {
      const { ethereum } = window;
      if (!ethereum || !ethereum.request) {
        console.log("make sure MetaMask is installed!");
        return;
      }

      const accounts = await ethereum.request({ method: 'eth_accounts' });
      if (accounts.length > 0) {
        setCurrentAccount(accounts[0]);
        await walletConnected();
      } else {
        console.log("make sure MetaMask is connected");
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const connectWallet = async () => {
    try {
      const { ethereum } = window;
      if (!ethereum || !ethereum.request) {
        console.log("make sure MetaMask is installed!");
        return;
      }

      const accounts = await ethereum.request({
        method: 'eth_requestAccounts'
      });

      setCurrentAccount(accounts[0]);
      await walletConnected();
    } catch (error) {
      console.log(error);
    }
  };

  const walletConnected = async () => {
    const buyMeACoffee = await getContract();
    if (!buyMeACoffee) {
      console.log("Contract not found!");
      return;
    }

    buyMeACoffee.on("NewMemo", onNewMemo);

    const memos = await buyMeACoffee.getMemos();
    setMemos(memos);
  };

  const onNewMemo = (from: string, timestamp: BigInt, name: string, message: string) => {
    setMemos(prevMemos => [{ from, timestamp, name, message }, ...prevMemos]);
  };

  const buyCoffee = async () => {
    try {
      const buyMeACoffee = await getContract();
      if (!buyMeACoffee) {
        console.log("Contract not found!");
        return;
      }

      const name = (document.getElementById("coffee-name") as HTMLInputElement).value || "Anonymous";
      const message = (document.getElementById("coffee-message") as HTMLInputElement).value || "No message";

      setLoading(true);
      const coffeeTxn = await buyMeACoffee.buyCoffee(name, message, {
        value: ethers.parseEther((quantity/100).toString())
      });

      await coffeeTxn.wait();
      setLoading(false);
      console.log("Coffee purchased!", coffeeTxn.hash);
    } catch (error) {
      setLoading(false);
      console.log("error: ", error);
    }
  };

  const getContract = async () => {
    const { ethereum } = window;
    if (!ethereum || !ethereum.request) {
      console.log("make sure MetaMask is installed!");
      return;
    }

    const provider = new ethers.BrowserProvider(ethereum as any, "any");
    const network = await provider.getNetwork();
    if (network.chainId !== 11155111n) {
      setErrorMessage("Please connect to the Sepolia Testnet");
      return;
    }

    setErrorMessage(null);
    const signer = await provider.getSigner();
    const buyMeACoffee = new ethers.Contract(contractAddress, contractABI, signer);
    return buyMeACoffee;
  };

  return (
    <div className="container">
      <h1>Buy Me a Coffee</h1>
      <p>If you like my work, consider buying me a coffee!</p>
      <p>Only Sepolia Testnet</p>

      {errorMessage && <div className="text-red-500 mb-4">{errorMessage}</div>}

      {!currentAccount && <button className="btn" onClick={connectWallet}>Connect Wallet</button>}

      {currentAccount && !errorMessage && (
        <div className="coffee-form">
          <input type="text" id="coffee-name" placeholder="Name" className="input" />
          <input type="text" id="coffee-message" placeholder="Message" className="input" />
          <input type="number" id="coffee-quantity" placeholder="Quantity" className="input" onChange={(e) => setQuantity(parseInt(e.target.value) || 0)} />
          <p>Total: {quantity * 0.01} ETH</p>
          <button className="btn" onClick={buyCoffee}>Buy Coffee</button>
          {loading && (
            <div className="loading">
              <div className="spinner"></div>
              <div>Processing your transaction...</div>
            </div>
          )}
        </div>
      )}

      <ul className="memo-list">
        {memos.map((memo, index) => (
          <li key={index} className="memo-item">
            <strong>{memo.name}</strong>
            <span> ({new Date(Number(memo.timestamp) * 1000).toLocaleString()}): </span>
            <span>{memo.message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
